import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1298.82353,1298.82353 C1222.36235,1298.82353 1158.32471,1247.54824 1137.31765,1177.97647 C1088.75294,1217.61882 1027.53882,1242.35294 960,1242.35294 C896.188235,1242.35294 837.910588,1220.32941 790.588235,1184.41412 L790.588235,1468.23529 L677.647059,1468.23529 L677.647059,960 L677.647059,903.529412 L677.647059,621.176471 L790.588235,621.176471 L790.588235,903.529412 L790.588235,960 C790.588235,1053.40235 866.597647,1129.41176 960,1129.41176 C1053.40235,1129.41176 1129.41176,1053.40235 1129.41176,960 L1129.41176,621.176471 L1242.35294,621.176471 L1242.35294,960 L1242.35294,1129.41176 C1242.35294,1160.58353 1267.76471,1185.88235 1298.82353,1185.88235 L1298.82353,1298.82353 Z M960,2.5243549e-29 C430.644706,2.5243549e-29 2.5243549e-29,430.644706 2.5243549e-29,960 C2.5243549e-29,1489.35529 430.644706,1920 960,1920 C1489.35529,1920 1920,1489.35529 1920,960 C1920,430.644706 1489.35529,2.5243549e-29 960,2.5243549e-29 L960,2.5243549e-29 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconQuizStatsAvgSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconQuizStatsAvgSolid, _Component);

  var _super = _createSuper(IconQuizStatsAvgSolid);

  function IconQuizStatsAvgSolid() {
    _classCallCheck(this, IconQuizStatsAvgSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconQuizStatsAvgSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconQuizStatsAvg",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconQuizStatsAvgSolid.displayName = "IconQuizStatsAvgSolid";
  return IconQuizStatsAvgSolid;
}(Component);

IconQuizStatsAvgSolid.glyphName = 'quiz-stats-avg';
IconQuizStatsAvgSolid.variant = 'Solid';
IconQuizStatsAvgSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconQuizStatsAvgSolid;
export { IconQuizStatsAvgSolid };